import { z } from 'zod';

import type { Database } from '../../../lib/database.types';

export const LEAD_STATUSES = ['new', 'contacted', 'qualified', 'disqualified'] as const;

export type LeadStatus = (typeof LEAD_STATUSES)[number];
export type LeadDisplayStatus = LeadStatus | 'converted';
export type LeadScoreClass = 'hot' | 'warm' | 'cold' | null;

export interface LeadFilters {
  search: string;
  statuses: LeadDisplayStatus[];
  sourceIds: (string | null)[];
  scoreClasses: LeadScoreClass[];
}

const optionalEmail = z
  .string()
  .trim()
  .optional()
  .refine((value) => !value || z.string().email().safeParse(value).success, 'אימייל לא תקין');

export const leadSchema = z.object({
  full_name: z.string().trim().min(1, 'שדה חובה').max(120, 'עד 120 תווים'),
  company_name: z.string().trim().max(120, 'עד 120 תווים').optional(),
  email: optionalEmail,
  phone: z.string().trim().optional(),
  source_id: z.string().uuid().optional().or(z.literal('')),
  interest: z.string().trim().max(200, 'עד 200 תווים').optional(),
  score: z.number().int().min(0).max(100).optional(),
  status: z.enum(LEAD_STATUSES),
  received_at: z.string().datetime().or(z.string().min(1, 'שדה חובה')),
  notes: z.string().trim().max(2000, 'עד 2000 תווים').optional(),
});

export type LeadInput = z.infer<typeof leadSchema>;

type LeadTableRow = Database['public']['Tables']['leads']['Row'];
type LeadSourceTableRow = Database['public']['Tables']['lead_sources']['Row'];

export type LeadRow = Pick<
  LeadTableRow,
  | 'id'
  | 'full_name'
  | 'company_name'
  | 'email'
  | 'phone'
  | 'source_id'
  | 'interest'
  | 'score'
  | 'score_class'
  | 'score_source'
  | 'status'
  | 'owned_by'
  | 'received_at'
  | 'created_at'
  | 'updated_at'
  | 'notes'
>;

export type LeadSourceRow = Pick<LeadSourceTableRow, 'id' | 'name' | 'slug' | 'color'>;
